import { ReactComponent as IconParticipants } from '@/assets/svgs/Participants.svg';
import { ReactComponent as IconDataDictionary } from '@/assets/svgs/SelectionYes.svg';
import { ReactComponent as IconUserManagement } from '@/assets/svgs/User-Management.svg';
import { ReactComponent as IconDownArrow } from '@/assets/svgs/caret-down.svg';
import { ReactComponent as IconActivity } from '@/assets/svgs/icon-activity.svg';
import { ReactComponent as IconApprovalRequests } from '@/assets/svgs/icon-approval-requests-nav.svg';
import { ReactComponent as IconDashboard } from '@/assets/svgs/icon-dashboard.svg';
import { ReactComponent as IconDataExchange } from '@/assets/svgs/icon-ds-data-element.svg';
import { ReactComponent as IconRelationShipSetup } from '@/assets/svgs/icon-ds-relation-status.svg';
import { ReactComponent as IconServiceProvider } from '@/assets/svgs/icon-ds-service-provider.svg';
import { ReactComponent as IconClient } from '@/assets/svgs/icon-ds-user-group.svg';
import { ReactComponent as IconHome } from '@/assets/svgs/icon-home.svg';
import { ReactComponent as IconUseCase } from '@/assets/svgs/icon-use-cases.svg';
import { ReactComponent as IconPitStop } from '@/assets/svgs/pitstop.svg';
import { NavigationLink } from '@/components/NavigationLink';
import { NavigationSubLink } from '@/components/NavigationSubLink';
import { useBuildex } from '@/hooks/use-buildex';
import useRouteMatchState from '@/hooks/use-route-match';
import { useTradex } from '@/hooks/use-tradex';
import { getDexConfig } from '@/utils/get-dex-config';
import { getEnvAndDex } from '@/utils/get-env-and-dex';
import { useSelector } from 'react-redux';

const Navigation = () => {
	const statuses = {
		approved: "APPROVED",
		rejected: "REJECTED",
		revoked: "REVOKED",
		pending: "PENDING",
		notEnrolled: "NOT_ENROLLED",
		signdsa: "DSA_REQUESTED",
		informationRequired: "INFO_REQUESTED"
	};

	const userTypes = {
		participant: "participant",
		admin: "admin",
		nonParticipant: "nonParticipant"
	};

	const userRole = {
		SUPER_ADMIN: "Super Admin",
		ADMIN: "Admin User",
		TECH_USER: "Tech User",
		OPS_USER: "Operation User"
	};

	const routes = [
		{ path: "/onboarding/*" }
	];

	const { routeStates, toggleVisibility, routeClasses } = useRouteMatchState(routes);

	const user = useSelector((state) => state.auth.user);
	const userType = useSelector((state) => state.auth.userType);
	const profile = useSelector((state) => state.auth.profile);

	/*=================================================
		MultiDex
	/================================================*/
	const { dex } = getEnvAndDex();
	const isBuildex = useBuildex();
	const isTradex = useTradex();
	const { LogoComponent } = getDexConfig(dex);

	return (
		<div className="navigation">
			<div className="navigation__header">
				<LogoComponent /> <span className="navigation__header__text">| Admin</span>
			</div>
			<div className="navigation__items">
				<div className="navigation__items__cols">
					<div className="navigation__items__col">
						{userType === userTypes.nonParticipant && (
							<>
								<NavigationLink to="/home" icon={<IconHome />} text="Home" />
								<NavigationLink to="/use-cases" icon={<IconUseCase />} text="Use Cases" />
							</>
						)}
						{userType === userTypes.participant && profile?.organization?.status !== statuses.notEnrolled && (
							<>
							{
								!isBuildex&&

								<NavigationLink to="/dashboard" icon={<IconDashboard />} text="Dashboard" />
							}
								{(isTradex && user.role?.some((role) => role.name === userRole.SUPER_ADMIN || role.name === userRole.ADMIN)) && (
									<NavigationLink to="/use-cases" icon={<IconUseCase />} text="Use Cases" />
								)}

								{/* Onboarding V2 */}
								{!isTradex && userType === userTypes.participant && profile?.organization?.status !== statuses.notEnrolled && (
									<>
										<div
											className={routeClasses['/onboarding/*']}
											onClick={() => toggleVisibility('/onboarding/*')}
											onKeyDown={(e) => {
												if (e.key === 'Enter' || e.key === ' '){
													toggleVisibility('/onboarding/*');
												}
											}}
											tabIndex="0"
											role="button"
											aria-label="Toggle Relationships Setup"
										>
											<div className="navigation-item__side__rectangle"></div>
											<div className="navigation-item__icon"><IconRelationShipSetup /></div>
											<div className="navigation-item__label">Relationships Setup</div>
											<div className="navigation-item__toggle">
												<IconDownArrow />
											</div>
										</div>
										{routeStates['/onboarding/*'].isVisible && (
											<div className="navigation__sub-items__cols">
												<div className="navigation__sub-items__col">
													<NavigationSubLink to="/onboarding/my-data-exchange" icon={<IconDataExchange />} text="My Data Exchange" />
													<NavigationSubLink to="/onboarding/my-service-provider" icon={<IconServiceProvider />} text="My Solution Provider" />
													<NavigationSubLink to="/onboarding/my-client" icon={<IconClient />} text="My Client" />
												</div>
											</div>
										)}
									</>
								)}

								{(user.role?.some((role) => role.name === userRole.SUPER_ADMIN)) && (
									<NavigationLink to="/user-management" icon={<IconUserManagement />} text="User Management" />
								)}
								{(user.role?.some((role) => role.name === userRole.SUPER_ADMIN || role.name === userRole.TECH_USER)) && (
									<>
										<NavigationLink to="/my-activities" icon={<IconActivity />} text="Activity Log" />
										<NavigationLink to="/pitstop" icon={<IconPitStop />} text="Pitstops" />
									</>
								)}
							</>
						)}
						{userType === userTypes.admin && (
							<>
								<NavigationLink to="/admin/participants" icon={<IconParticipants />} text="Participants" />
								<NavigationLink to="/admin/approval-requests" icon={<IconApprovalRequests />} text="Approvals" />
								<NavigationLink to="/my-activities" icon={<IconActivity />} text="Activity Log" />
							</>
						)}
						<NavigationLink to="/data-dictionary" icon={<IconDataDictionary />} text="Data Dictionary" />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Navigation;
